import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import currencyCodes from "currency-codes";
import { Autocomplete, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Moment } from 'moment';
import DatePresets from '../../../dashboard/callAnalysis/datePresets';
import datePickerStyles from "../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import feedbackStyles from "../../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import { ageGroupOptions, emptyProductQrCodeObj, formatOptionalDateRangeValue, genderOptions, getDefaultPayload, getGenericDataTypeName, getGtinValidationMessage, getOptionalFieldInputType, getSalePriceValidationMessage, OPTIONAL_DATE_RANGE_DISPLAY_FORMAT, parseOptionalDateRangeValue, productFields, requiredWhenWhatsAppCatalogFieldKeys, sortCatalogProductOptionalField, whatsappCatalogMaxLengthValidation } from './productConstant';
import style from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import productStyles from "../../../../assets/styles/componentStyles/productStyles/productStyles.module.scss";
import globalStyle from "../../../../assets/styles/global.module.scss";
import WACampaignStyles from "../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import Required from '../../../utility/required';
import { catalogProductOptionalDataItem, catalogProductOptionalField, createUpdateProductPayload, EcomProduct, qrCodeData, uploadProductColumnMapping } from '../../../../models/axiosModel';
import GlobalButton from '../../../utility/globalButton/button';
import getSymbolFromCurrency from 'currency-symbol-map'
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { getFileTypeImgIcon, getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from '../../../../utils/constants';
import FileUpload from '../../../utility/fileUpload/fileUpload';
import { debounce } from 'lodash';
import validator from 'validator';
import agent from '../../../../services/api';
import PrimaryIOSSwitch from '../../../utility/switch/primaryIOSSwitch';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { primaryColor } from '../../../../utils/colors';
import IconsColor from '../../../utility/iconsColor';
import DeleteIcon from '@mui/icons-material/Delete';
import { useGenericStore } from '../../../../store/genericStore';
import { useProductStore } from '../../../../store/productStore';
import { useShallow } from 'zustand/react/shallow';
import CatalogOptionalMultipleField from './catalogOptionalMultipleField';

interface CreateSingleProductProps {
    selectedProduct?: EcomProduct,
    getEComProductApiCall: () => Promise<void>,
    onClickOfCancel: () => void,
    getWhatsAppCatalogsDataApiCall: () => Promise<void>,
    getCatalogProductOptionalFieldApiCall: () => Promise<void>
}

interface dropdownOption {
    label: string,
    value: string,
}

export type productFormField = (typeof productFields)[number] & {
    isCatalogOptionalField?: boolean,
    optionalField?: catalogProductOptionalField,
};

const buildOptionalFieldMultiMap = (optionalFields?: catalogProductOptionalField[] | null) => {
    return (optionalFields ?? []).reduce<Record<string, boolean>>((acc, field) => {
        acc[field.catalog_product_optional_field_id] = Boolean(field.flag_allowed_multiple);
        return acc;
    }, {});
};

const normalizeCatalogOptionalDataForEdit = (existingData: catalogProductOptionalDataItem[], optionalFields?: catalogProductOptionalField[] | null): catalogProductOptionalDataItem[] => {
    const multiFieldMap = buildOptionalFieldMultiMap(optionalFields);

    return (existingData ?? []).flatMap((item) => {
        const isMultipleAllowed = Boolean(multiFieldMap[item.catalog_product_optional_field_id]);
        if (!isMultipleAllowed) {
            return [item];
        }

        const splitValues = String(item.catalog_product_optional_data_value ?? "")?.split(",")?.map((value) => value.trim())?.filter((value) => value.length > 0);

        if (!splitValues.length) {
            return [{
                ...item,
                catalog_product_optional_data_value: "",
            }];
        }

        return splitValues.map((value) => ({
            ...item,
            catalog_product_optional_data_value: value,
        }));
    });
};

const getInitialCatalogProductOptionalData = (product?: EcomProduct, optionalFields?: catalogProductOptionalField[] | null): catalogProductOptionalDataItem[] => {
    const existingData = product?.catalog_product_optional_data;
    if (Array.isArray(existingData) && existingData.length > 0) {
        return normalizeCatalogOptionalDataForEdit(existingData, optionalFields);
    }

    return (optionalFields ?? []).map((field) => ({
        catalog_product_optional_field_id: field.catalog_product_optional_field_id,
        catalog_product_optional_data_value: "",
    }));
};

const getOptionalFieldValueFromPayload = (fieldId: string, optionalData?: catalogProductOptionalDataItem[]) => {
    if(Array.isArray(optionalData)){
        return (optionalData ?? [])?.filter((item) => item.catalog_product_optional_field_id === fieldId)?.map((item) => String(item.catalog_product_optional_data_value ?? "").trim())?.filter((value) => value.length > 0)?.join(",");
    }
    return "";
};

const CreateSingleProduct: React.FC<CreateSingleProductProps> = (props) => {

    const { selectedProduct, getEComProductApiCall, onClickOfCancel, getWhatsAppCatalogsDataApiCall, getCatalogProductOptionalFieldApiCall } = props;
    const { setFlagLoading, flagLoading, handleError, vendorData, userDetail } = useContext(UserContext) as UserContextPayload;
    const userTimezone = userDetail?.timezone_hour ?? "";

    const innerHeight = window.innerHeight - 265;

    const [payload, setPayload] = useState<createUpdateProductPayload>(getDefaultPayload(selectedProduct));
    const [files, setFiles] = useState<any>([]);
    const [progress, setProgress] = useState({ filename: "", percent: 0 });
    const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);

    const [inValidUrlField, setInValidUrlField] = useState<string[]>([]);
    const inValidUrlFieldRef = useRef<string[]>([]);
    const [flagValidJson, setFlagValidJson] = useState<boolean>(true);
    const [optionalDateRangePickerState, setOptionalDateRangePickerState] = useState<{fieldId: string | null, focusedInput: FocusedInputShape | null}>({ fieldId: null, focusedInput: null });

    const tabScreen = useMediaQuery('(max-width : 1000px) and (min-width : 0px)');

    const { genericDataTypeList, getGenericDataTypeApi, showSuccess, showError } = useGenericStore(useShallow((state) => ({
        genericDataTypeList: state.genericDataTypeList,
        getGenericDataTypeApi: state.getGenericDataTypeApi,
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { whatsAppCatalogsData, getWhatsAppCatalogsDataApi, catalogProductOptionalFieldData, getCatalogProductOptionalFieldApi } = useProductStore(useShallow((state) => ({
        whatsAppCatalogsData: state.whatsAppCatalogsData,
        getWhatsAppCatalogsDataApi: state.getWhatsAppCatalogsDataApi,
        catalogProductOptionalFieldData: state.catalogProductOptionalFieldData,
        getCatalogProductOptionalFieldApi: state.getCatalogProductOptionalFieldApi,
    })))

    const hasWhatsAppCatalogsData = (whatsAppCatalogsData?.length ?? 0) > 0;
    const isWhatsAppCatalogSelected = hasWhatsAppCatalogsData && Boolean(String(payload?.wa_catalog_id ?? "").trim());

    const whatsAppCatalogOptions = useMemo(() => {
        return (whatsAppCatalogsData ?? []).map((catalog) => ({
            value: catalog.wa_catalog_id,
            label: `${catalog.wa_catalog_name} (${catalog.waba_name})`,
        }));
    }, [whatsAppCatalogsData]);

    const visibleProductFields = useMemo(() => {
        return productFields.filter((field) => {
            if (field?.key === "wa_catalog_id") {
                return hasWhatsAppCatalogsData;
            }
            if (field?.flag_show_when_whatsapp_catalog) {
                return isWhatsAppCatalogSelected;
            }
            if(field?.key === "flag_ecom_product_qr_code"){
                return !isWhatsAppCatalogSelected;
            }
            return true;
        });
    }, [hasWhatsAppCatalogsData, isWhatsAppCatalogSelected]);

    const sortedCatalogOptionalFields = useMemo(() => {
        return sortCatalogProductOptionalField(catalogProductOptionalFieldData);
    }, [catalogProductOptionalFieldData]);

    const formFieldsToRender = useMemo(() => {
        if (!isWhatsAppCatalogSelected || !sortedCatalogOptionalFields?.length) {
            return visibleProductFields as productFormField[];
        }

        const optionalFieldsAsFormFields: productFormField[] = sortedCatalogOptionalFields.map((optionalField) => ({
            name: optionalField.field_name,
            key: optionalField.field_key,
            getCallResponseKey: optionalField.field_key,
            flag_required: false,
            flag_additional_info: false,
            field_placeholder: `Enter ${optionalField.field_name.toLowerCase()}`,
            xs_value: 6,
            isCatalogOptionalField: true,
            optionalField,
            flag_dropdown: optionalField?.field_key === "gender" || optionalField?.field_key === "age_group",
            options: optionalField?.field_key === "gender" ? genderOptions : optionalField?.field_key === "age_group" ? ageGroupOptions : [],
            flag_show_when_whatsapp_catalog: true
        }));

        const itemGroupIndex = visibleProductFields.findIndex((field) => field?.key === "ecom_product_item_group_id");
        const insertIndex = itemGroupIndex >= 0 ? itemGroupIndex + 1 : visibleProductFields.length;

        return [
            ...visibleProductFields.slice(0, insertIndex),
            ...optionalFieldsAsFormFields,
            ...visibleProductFields.slice(insertIndex),
        ] as productFormField[];
    }, [visibleProductFields, isWhatsAppCatalogSelected, sortedCatalogOptionalFields]);

    const isFieldRequired = (field: productFormField) => {
        if (isWhatsAppCatalogSelected && requiredWhenWhatsAppCatalogFieldKeys.includes(field?.key)) {
            return true;
        }
        return field?.flag_required ?? false;
    };

    const isOptionalNumberInputField = (optionalField?: catalogProductOptionalField, optionalFieldInputType?: string) => {
        const fieldKey = optionalField?.field_key?.toLowerCase();
        return optionalFieldInputType === "number" || fieldKey === "sale_price";
    };

    const getFieldDropdownOptions = (field: productFormField): dropdownOption[] => {
        switch(field?.key){
            case 'wa_catalog_id':
                return whatsAppCatalogOptions;
            case 'product_price_currency':
                return currencyOptions;
            default:
                return field?.options ?? [];
        }
    };

    const uploadFileHandler = async (e: any) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setFiles([file]);

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }
            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData, config).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                // rr.page_field_id = id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })
                    setPayload((prev) => ({
                        ...prev,
                        product_image: res.data.data.file_path,
                    }))
                    setIsFileUploaded(false);
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                console.error(err)
            });
            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }

    const removeFileHandler = async () => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        await agent.removeUploadedFile.delete(files[0].file_data.google_storage_id).then(async (res) => {
            if (res.data.status) {
                setFiles([]);
                showSuccess("File Deleted Successfully")
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        setFiles([]);
    }

    const currencyOptions = useMemo(() => {
        return currencyCodes.data.filter((currency) => getSymbolFromCurrency(currency.code))?.map((currency) => {
            return {
                value: currency.code,
                label: `${currency.code} — ${currency.currency} (${getSymbolFromCurrency(currency.code)})`,
            };
        });
    }, []);

    const onChangeOfOptionalFieldValue = (fieldId: string, value: string, inputType: string) => {
        setPayload((prev) => {
            const existingData = prev.catalog_product_optional_data ?? [];
            const updatedData = [
                ...existingData.filter((item) => item.catalog_product_optional_field_id !== fieldId),
                {
                    catalog_product_optional_field_id: fieldId,
                    catalog_product_optional_data_value: value,
                },
            ];

            return {
                ...prev,
                catalog_product_optional_data: updatedData,
            };
        });

        if (inputType === "url") {
            onBlurOfFallBackOfBtnVar(value, fieldId);
        }
    };

    const onChangeOfOptionalDateRangeValue = (fieldId: string, startDate: Moment | null, endDate: Moment | null, previousStartDate: Moment | null) => {
        let updatedEndDate = endDate;
        if (startDate != previousStartDate) {
            updatedEndDate = null;
        }
        onChangeOfOptionalFieldValue(fieldId, formatOptionalDateRangeValue(startDate, updatedEndDate, userTimezone), "date range");
    };

    const getFieldValueForValidation = (field: productFormField) => {
        if (field?.isCatalogOptionalField && field?.optionalField) {
            return getOptionalFieldValueFromPayload(field.optionalField.catalog_product_optional_field_id, payload.catalog_product_optional_data);
        }
        return payload[field?.key as keyof createUpdateProductPayload];
    };

    const getFieldLengthValidationMessage = (field: productFormField) => {
        if (!isWhatsAppCatalogSelected) {
            return "";
        }

        const maxLengthAllowed = whatsappCatalogMaxLengthValidation[field?.key as keyof typeof whatsappCatalogMaxLengthValidation];
        if (!maxLengthAllowed) {
            return "";
        }

        const fieldValue = String(getFieldValueForValidation(field) ?? "");
        if (fieldValue.length > maxLengthAllowed) {
            return `Maximum ${maxLengthAllowed} characters allowed`;
        }

        return "";
    };

    const getFieldValidationMessage = (field: productFormField) => {
        const lengthValidationMessage = getFieldLengthValidationMessage(field);
        if (lengthValidationMessage) {
            return lengthValidationMessage;
        }

        if (field?.optionalField?.field_key === "sale_price") {
            return getSalePriceValidationMessage(getFieldValueForValidation(field), payload.product_price);
        }

        if (field?.optionalField?.field_key?.toLowerCase() === "gtin") {
            return getGtinValidationMessage(getFieldValueForValidation(field));
        }

        return "";
    };

    const shouldShowOptionalFieldValidationBorder = (optionalField?: catalogProductOptionalField, validationMessage?: string) => {
        if (!validationMessage || !optionalField) {
            return false;
        }

        const fieldKey = optionalField.field_key?.toLowerCase();
        return fieldKey === "sale_price" || fieldKey === "gtin";
    };

    const checkDisableSaveButton = () => {
        for (let i = 0; i < formFieldsToRender?.length; ++i) {
            const field = formFieldsToRender[i];
            const value = getFieldValueForValidation(field);
            if (isFieldRequired(field) && String(value ?? "")?.trim()?.length == 0) {
                return true;
            }
            if (getFieldValidationMessage(field)) {
                return true;
            }
        }
        if (!flagValidJson || inValidUrlField?.length > 0) {
            return true;
        }

        return payload?.ecom_product_qr_code_data?.some((qrCode) => {
            if(qrCode?.flag_expiry){
                if(!qrCode?.ecom_product_qr_code_validity_start_timestamp_unix || !qrCode?.ecom_product_qr_code_validity_end_timestamp_unix){
                    return true;
                }
            }
        })
    }

    const handleCreateClick = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const optionalFieldMultiMap = buildOptionalFieldMultiMap(catalogProductOptionalFieldData);
        const expandedCatalogOptionalData = (payload?.catalog_product_optional_data ?? []).flatMap((item) => {
            const fieldId = item?.catalog_product_optional_field_id;
            const fieldValue = String(item?.catalog_product_optional_data_value ?? "").trim();

            if (!fieldId || !fieldValue.length) {
                return [];
            }

            if (!optionalFieldMultiMap[fieldId]) {
                return [{
                    catalog_product_optional_field_id: fieldId,
                    catalog_product_optional_data_value: fieldValue,
                }];
            }

            return fieldValue
                .split(",")
                .map((value) => value.trim())
                .filter((value) => value.length > 0)
                .map((value) => ({
                    catalog_product_optional_field_id: fieldId,
                    catalog_product_optional_data_value: value,
                }));
        });

        const parsedJsonPayload = {
            ...payload,
            catalog_product_optional_data: expandedCatalogOptionalData,
            additional_information_json: payload?.additional_information_json ? JSON.parse(payload?.additional_information_json) : "",
        }
        let res;
        if (!selectedProduct) {
            res = await agent.addEComProduct.post(parsedJsonPayload);
        } else {
            res = await agent.updateEComProduct.put(parsedJsonPayload);
        }
        if (res.status) {
            showSuccess(`Product ${selectedProduct ? 'updated' : 'added'} successfully.`)
            getEComProductApiCall();
        } else {
            handleError(res);
        }
        onClickOfCancel();
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const handleValidWebsite = (website_value: string, key: string) => {
        const trimmedValue = website_value?.trim() ?? "";

        if (!trimmedValue.length) {
            if (inValidUrlFieldRef.current.includes(key)) {
                inValidUrlFieldRef.current = inValidUrlFieldRef.current.filter((field) => field !== key);
                setInValidUrlField((prev) => prev.filter((field) => field !== key));
            }
            return;
        }

        // For multiple chips we store comma-separated URLs; validate each non-empty chip separately.
        const urlValues = trimmedValue?.split(",")?.map((value) => value?.trim())?.filter((value) => value.length > 0);

        const isValid = urlValues?.every((url) => validator.isURL(url, { require_protocol: true }));

        if (isValid) {
            inValidUrlFieldRef.current = inValidUrlFieldRef.current.filter((field) => field !== key);
            setInValidUrlField((prev) => prev.filter((field) => field !== key));
            return;
        }

        if (!inValidUrlFieldRef.current.includes(key)) {
            inValidUrlFieldRef.current = [...inValidUrlFieldRef.current, key];
            setInValidUrlField((prev) => [...prev, key]);
        }
    }

    const onBlurOfFallBackOfBtnVar = useCallback(
        debounce((value: string, key: string) => {
            handleValidWebsite(value, key);
        }, 1200), []
    );

    const onChangeOfValue = (key: keyof createUpdateProductPayload, value: any, flagValidateUrl?: boolean) => {
        if (key === "wa_catalog_id" && !String(value ?? "").trim()) {
            setOptionalDateRangePickerState({ fieldId: null, focusedInput: null });
        }

        setPayload((prev) => {
            if (key === "wa_catalog_id") {
                if (!String(value ?? "").trim()) {
                    return {
                        ...prev,
                        wa_catalog_id: "",
                        waba_id: "",
                        ecom_product_availability: "",
                        ecom_product_condition: "",
                        ecom_product_link: "",
                        ecom_product_brand: "",
                        ecom_product_item_group_id: "",
                        catalog_product_optional_data: [],
                        ecom_product_qr_code_data: [],
                        ecom_product_qr_code_count: 0,
                        flag_ecom_product_qr_code: false
                    };
                }

                const selectedCatalog = whatsAppCatalogsData?.find(
                    (catalog) => catalog.wa_catalog_id === value
                );

                return {
                    ...prev,
                    wa_catalog_id: value,
                    waba_id: selectedCatalog?.waba_id ?? "",
                    ecom_product_qr_code_data: [],
                    ecom_product_qr_code_count: 0,
                    flag_ecom_product_qr_code: false
                };
            }

            return {
                ...prev,
                [key]: value,
            };
        });

        if (flagValidateUrl) {
            onBlurOfFallBackOfBtnVar(value, key);
        } else if (key?.toLowerCase() == "additional_information_json") {
            let replaceStr = value.replace(/\n(?=\s*[{[(])/g, '').replace(/(?<=[}\])])\n/g, '');
            try {
                JSON.parse(replaceStr);
                setFlagValidJson(true);
            } catch (e) {
                setFlagValidJson(value?.length > 0 ? false : true);
            }
        }

        if(key?.toLowerCase() == 'flag_ecom_product_qr_code'){
            setPayload((prev) => {
                return {
                    ...prev,
                    ecom_product_qr_code_data: value ? [emptyProductQrCodeObj] : [],
                    ecom_product_qr_code_count:  value ? 1 : 0
                }
            })
        }
    }

    const onChangeOfQRCodeData = (index: number, key: keyof qrCodeData, value: any) => {
        setPayload((prev) => {
            return {
                ...prev, 
                ecom_product_qr_code_data: prev?.ecom_product_qr_code_data?.map((qrCode, ind) => {
                    if(ind === index){
                        if(key == 'flag_expiry'){
                            return {
                                ...qrCode,
                                [key]: value,
                                ecom_product_qr_code_validity_start_timestamp_unix: null,
                                ecom_product_qr_code_validity_end_timestamp_unix: null
                            }   
                        }
                        return {
                            ...qrCode,
                            [key]: value
                        }
                    }
                    return qrCode;
                })
            }
        })
    }

    const addQrCode = () => {
        setPayload((prev) => ({
            ...prev,
            ecom_product_qr_code_count: prev?.ecom_product_qr_code_count + 1,
            ecom_product_qr_code_data: [...prev?.ecom_product_qr_code_data, emptyProductQrCodeObj]
        }));
    }

    const deleteQrCodeData = (index: number) => {
        setPayload((prev) => ({
            ...prev,
            ecom_product_qr_code_count: prev?.ecom_product_qr_code_count - 1,
            ecom_product_qr_code_data: prev?.ecom_product_qr_code_data?.filter((qrCode, ind) => ind != index)
        }))
    }

    const getGenericDataTypeListApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getGenericDataTypeApi();
        if(!(res?.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(process.env.REACT_APP_META_CATALOG_API_ENABLED == "true"){
            if(!genericDataTypeList){
                getGenericDataTypeListApiCall();
            }
            if (!whatsAppCatalogsData) {
                getWhatsAppCatalogsDataApiCall();
            }
            if (!catalogProductOptionalFieldData) {
                getCatalogProductOptionalFieldApiCall();
            }
        }
    }, []);

    useEffect(() => {
        if (!catalogProductOptionalFieldData?.length || !selectedProduct) {
            return;
        }
        setPayload((prev) => ({
            ...prev,
            catalog_product_optional_data: getInitialCatalogProductOptionalData(selectedProduct, catalogProductOptionalFieldData)
        }));
    }, [selectedProduct, catalogProductOptionalFieldData]);

    useEffect(() => {
        if (!payload?.wa_catalog_id || payload?.waba_id || !whatsAppCatalogsData?.length) {
            return;
        }
        const selectedCatalog = whatsAppCatalogsData.find(
            (catalog) => catalog.wa_catalog_id === payload.wa_catalog_id
        );
        if (selectedCatalog?.waba_id) {
            setPayload((prev) => ({
                ...prev,
                waba_id: selectedCatalog.waba_id,
            }));
        }
    }, [whatsAppCatalogsData, payload?.wa_catalog_id, payload?.waba_id]);

    return (
        <>
            <Grid container gap={2}>
                <Grid item xs={12} className={`${globalStyle.fullwidth} ${productStyles.singleProductMainGrid}`} sx={{ maxHeight: `${innerHeight}px` }}>
                    <Grid container spacing={2}>
                        {formFieldsToRender?.map((field, ind) => {
                            const fieldDropdownOptions = getFieldDropdownOptions(field);
                            const fieldIsRequired = isFieldRequired(field);
                            const optionalField = field?.optionalField;
                            const optionalFieldInputType = optionalField ? getOptionalFieldInputType(getGenericDataTypeName(optionalField.data_type_id, genericDataTypeList)): "text";
                            const optionalFieldValue = optionalField? getOptionalFieldValueFromPayload(optionalField.catalog_product_optional_field_id, payload.catalog_product_optional_data) : "";
                            const parsedOptionalDateRange = optionalFieldInputType === "date range" ? parseOptionalDateRangeValue(optionalFieldValue) : { startDate: null, endDate: null };
                            const optionalFieldId = optionalField?.catalog_product_optional_field_id ?? "";
                            const isOptionalDateRangeFocused = optionalDateRangePickerState.fieldId === optionalFieldId;
                            const fieldValidationMessage = getFieldValidationMessage(field);

                            return (
                                <Grid item key={`${field?.key}-${ind}`} lg={field.xs_value} xs={12}>
                                    <Grid container className={style.createContactFieldContainer}>
                                        {field?.name?.toLowerCase() === "qr code" ? 
                                            (
                                                <Grid container alignItems="center" justifyContent={'space-between'} gap={1}>
                                                    <Grid item>
                                                        <Grid container alignItems={'center'} gap={1}>
                                                            <Typography className={style.popupFieldTypography}>
                                                                {field.name} {fieldIsRequired && <Required />}
                                                            </Typography>

                                                            <PrimaryIOSSwitch
                                                                checked={payload[field?.key as keyof createUpdateProductPayload] as boolean}
                                                                onChange={(e) =>
                                                                    onChangeOfValue(field?.key as keyof createUpdateProductPayload, e.target.checked)
                                                                }
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    {payload[field?.key as keyof createUpdateProductPayload] && 
                                                        <Grid item>
                                                            <span
                                                                className={`${globalStyle.primaryColor} ${globalStyle.displayFlex} ${globalStyle.clickable} ${globalStyle.gapOne} ${globalStyle.secondaryFontSize} ${globalStyle.primaryFontWeight}`}
                                                                onClick={() => addQrCode()}
                                                            >
                                                                <IconsColor iconName='plus' width="15" height="15" fillColor={primaryColor} />
                                                                Add
                                                            </span>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            )
                                            :
                                            (
                                                <>
                                                    <Grid xs={12}>
                                                        <Grid container gap="5px" alignItems={"center"}>
                                                            <Typography className={style.popupFieldTypography}>{field.name} {fieldIsRequired && <Required />}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid xs={12}>
                                                        {field?.isCatalogOptionalField && optionalField ?
                                                            optionalField?.flag_allowed_multiple ?
                                                                <CatalogOptionalMultipleField
                                                                    storedValue={optionalFieldValue}
                                                                    onChipsChange={(chips) => onChangeOfOptionalFieldValue(optionalField.catalog_product_optional_field_id, chips.join(","), optionalFieldInputType)}
                                                                    placeholder={field?.field_placeholder}
                                                                    textFieldClassName={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                                    hasInvalidUrl={optionalFieldInputType === "url" && inValidUrlField.includes(optionalField.catalog_product_optional_field_id)}
                                                                />
                                                                :
                                                            field?.flag_dropdown ?
                                                                <Autocomplete
                                                                    className={`${style.contactFilterDropdownsInPopup}`}
                                                                    options={field?.options ?? []}
                                                                    getOptionLabel={(option) => option?.label ?? ""}
                                                                    value={field?.options?.find((option) => option.value === optionalFieldValue) ?? null}
                                                                    onChange={(_: React.SyntheticEvent, value: dropdownOption | null) => onChangeOfOptionalFieldValue(optionalField.catalog_product_optional_field_id, value?.value ?? "", optionalFieldInputType)}
                                                                    renderInput={(params) => <TextField {...params} placeholder={field?.field_placeholder} />}
                                                                />
                                                                :
                                                            optionalFieldInputType?.toLowerCase() === "date range" ?
                                                                <Grid item className={`${datePickerStyles.dateRangePickerClass} ${feedbackStyles.dateRangePickerClass} ${style.dateRangePickerClass} ${productStyles.dateRangePicker}`}>
                                                                    <DateRangePicker
                                                                        startDate={parsedOptionalDateRange.startDate}
                                                                        startDateId={`${optionalFieldId}_start`}
                                                                        endDate={parsedOptionalDateRange.endDate}
                                                                        endDateId={`${optionalFieldId}_end`}
                                                                        readOnly
                                                                        onDatesChange={({ startDate, endDate }) => {
                                                                            onChangeOfOptionalDateRangeValue(optionalFieldId, startDate, endDate, parsedOptionalDateRange.startDate);
                                                                        }}
                                                                        focusedInput={isOptionalDateRangeFocused ? optionalDateRangePickerState.focusedInput : null}
                                                                        displayFormat={OPTIONAL_DATE_RANGE_DISPLAY_FORMAT}
                                                                        numberOfMonths={tabScreen ? 1 : 2}
                                                                        minimumNights={0}
                                                                        onFocusChange={(focusedInput) => {
                                                                            setOptionalDateRangePickerState({
                                                                                fieldId: focusedInput ? optionalFieldId : null,
                                                                                focusedInput,
                                                                            });
                                                                        }}
                                                                        isOutsideRange={() => false}
                                                                    />
                                                                </Grid>
                                                                :
                                                            <TextField
                                                                type={isOptionalNumberInputField(optionalField, optionalFieldInputType) ? "number" : "text"}
                                                                inputProps={isOptionalNumberInputField(optionalField, optionalFieldInputType) ? { min: 0 } : undefined}
                                                                value={optionalFieldValue}
                                                                onChange={(e) => onChangeOfOptionalFieldValue(optionalField.catalog_product_optional_field_id, e.target.value, optionalFieldInputType)}
                                                                className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                                placeholder={field?.field_placeholder}
                                                                sx={{
                                                                    border: (optionalFieldInputType === "url" && inValidUrlField.includes(optionalField.catalog_product_optional_field_id)) || shouldShowOptionalFieldValidationBorder(optionalField, fieldValidationMessage) ? "1px solid red" : "",
                                                                }}
                                                            />
                                                            :
                                                        field?.flag_dropdown ?
                                                            <Autocomplete
                                                                className={`${style.contactFilterDropdownsInPopup}`}
                                                                options={fieldDropdownOptions}
                                                                getOptionLabel={(option) => option?.label ?? ''}
                                                                value={fieldDropdownOptions?.find((option) => option?.value == payload[field?.key as keyof createUpdateProductPayload]) ?? null}
                                                                onChange={(_: React.SyntheticEvent, value: dropdownOption | null) => onChangeOfValue(field?.key as keyof createUpdateProductPayload, value ? value?.value : "")}
                                                                renderInput={(params) => <TextField {...params} placeholder={`${field.field_placeholder}`} />}
                                                            />
                                                            :
                                                            (field?.name?.toLowerCase() == "product description" || field?.name?.toLowerCase() == "additional information") ?
                                                                <>
                                                                    <textarea
                                                                        rows={1}
                                                                        placeholder={field?.field_placeholder}
                                                                        className={style.textareaStyle}
                                                                        value={payload[field?.key as keyof createUpdateProductPayload] as string ?? ""}
                                                                        onChange={(e) => onChangeOfValue(field?.key as keyof createUpdateProductPayload, e.target.value)}
                                                                    />
                                                                    {!flagValidJson && field?.name?.toLowerCase() == "additional information" &&
                                                                        <Typography className={`${WACampaignStyles.invalidUrlSpan}`}>Please Enter Valid JSON</Typography>
                                                                    }
                                                                </>
                                                                :
                                                                // (field?.name?.toLowerCase() == "product image") ?
                                                                (field?.flag_file_upload) ?
                                                                    <Grid container gap={"12px"} flexWrap={"nowrap"}>
                                                                        <Grid item xs={field?.name?.toLowerCase() == "product image" ? 11 : 12}>
                                                                            <Grid container direction={"column"}>
                                                                                <TextField
                                                                                    value={payload[field?.key as keyof createUpdateProductPayload] || ""}
                                                                                    placeholder={field?.field_placeholder}
                                                                                    onChange={(e) => { onChangeOfValue(field?.key as keyof createUpdateProductPayload, e.target.value, true) }}
                                                                                    className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                                                    sx={{ border: inValidUrlField.includes(field?.key) ? "1px solid red" : "" }}
                                                                                />
                                                                                {inValidUrlField.includes(field?.key) && <span className={WACampaignStyles.invalidUrlSpan}>Please Enter Valid URL</span>}
                                                                            </Grid>
                                                                        </Grid>
                                                                        {field?.name?.toLowerCase() == "product image" && 
                                                                            <Grid item>
                                                                                <FileUpload
                                                                                    uploadedFileDetails={files}
                                                                                    multipleFileAllow={true}
                                                                                    fileSizeAllowed={getWhatsappMediaSizeLimit("image")}
                                                                                    fileTypeAllowed={getWhatsappMediaAllowedFileTypes("image")?.allowedType}
                                                                                    fileNumberAllowed={2}
                                                                                    uploadFileHandler={(e: any) => uploadFileHandler(e)}
                                                                                    removeFileHandler={removeFileHandler}
                                                                                    isDeleteFileIconVisible={isFileUploaded}
                                                                                    flagShowJustIcon={true}
                                                                                    isDisabled={false}
                                                                                    flagWhatsapp={true}
                                                                                />
                                                                            </Grid>
                                                                        }
                                                                    </Grid>
                                                                    :
                                                                    <TextField
                                                                        type={field?.name?.toLowerCase() == "product price" ? 'number' : 'text'}
                                                                        inputProps={{ min: 0 }}
                                                                        value={payload[field?.key as keyof createUpdateProductPayload]}
                                                                        onChange={(e) => onChangeOfValue(field?.key as keyof createUpdateProductPayload, e.target.value)}
                                                                        className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                                        placeholder={`${field.field_placeholder}`}
                                                                    />
                                                        }
                                                        {field?.isCatalogOptionalField && optionalFieldInputType === "url" && inValidUrlField.includes(optionalField?.catalog_product_optional_field_id ?? "") &&
                                                            <span className={WACampaignStyles.invalidUrlSpan}>Please Enter Valid URL</span>
                                                        }
                                                        {fieldValidationMessage &&
                                                            <span className={WACampaignStyles.invalidUrlSpan}>{fieldValidationMessage}</span>
                                                        }
                                                    </Grid>
                                                </>
                                            )
                                        }
                                    </Grid>
                                </Grid>
                            );
                        })}

                        {payload?.ecom_product_qr_code_data && payload?.ecom_product_qr_code_data?.length > 0 && 
                            <Grid item xs={12}>
                                <Grid container direction={'column'} gap={1}>
                                    {payload?.ecom_product_qr_code_data?.map((qrCode, index) => {
                                        return (
                                            <Grid item xs={12} className={`${globalStyle.fullwidth}`}>
                                                <Grid container direction={'column'} gap={2} className={`${productStyles.qrCodeDataContainer} ${payload?.ecom_product_qr_code_data?.length > 1 ? productStyles.qrCodeDataWrapper : ''}`}>
                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                        <Grid container gap={1} className={globalStyle.displayFlex}>
                                                            <Grid item>
                                                                <Typography className={style.popupFieldTypography}>
                                                                    Flag Expiry
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <PrimaryIOSSwitch
                                                                    checked={qrCode?.flag_expiry}
                                                                    onChange={(e) => onChangeOfQRCodeData(index, 'flag_expiry', e.target.checked)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    {qrCode?.flag_expiry && 
                                                        <>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <Grid container gap={1} className={globalStyle.displayFlex} direction={'column'}>
                                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                        <Typography className={style.popupFieldTypography}>
                                                                            Start Time <Required />
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} className={`${globalStyle.fullwidth} ${productStyles.dateTimePicker}`}>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DemoContainer components={['DateTimePicker']}>
                                                                                <DateTimePicker
                                                                                    disablePast
                                                                                    value={qrCode?.ecom_product_qr_code_validity_start_timestamp_unix ? dayjs.unix(qrCode?.ecom_product_qr_code_validity_start_timestamp_unix) : null}
                                                                                    maxDateTime={qrCode?.ecom_product_qr_code_validity_end_timestamp_unix ? dayjs.unix(qrCode?.ecom_product_qr_code_validity_end_timestamp_unix) : null}
                                                                                    onChange={(newVal) => onChangeOfQRCodeData(index, 'ecom_product_qr_code_validity_start_timestamp_unix', newVal?.unix() ?? null)}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            className: productStyles.dateTimePickerSlotProps,
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </DemoContainer>
                                                                        </LocalizationProvider>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <Grid container gap={1} className={globalStyle.displayFlex} direction={'column'}>
                                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                        <Typography className={style.popupFieldTypography}>
                                                                            End Time <Required />
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} className={`${globalStyle.fullwidth} ${productStyles.dateTimePicker}`}>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DemoContainer components={['DateTimePicker']}>
                                                                                <DateTimePicker
                                                                                    disablePast
                                                                                    value={qrCode?.ecom_product_qr_code_validity_end_timestamp_unix ? dayjs.unix(qrCode?.ecom_product_qr_code_validity_end_timestamp_unix) : null}
                                                                                    minDateTime={qrCode?.ecom_product_qr_code_validity_start_timestamp_unix ? dayjs.unix(qrCode?.ecom_product_qr_code_validity_start_timestamp_unix) : dayjs()}
                                                                                    onChange={(newVal) => onChangeOfQRCodeData(index, 'ecom_product_qr_code_validity_end_timestamp_unix', newVal?.unix() ?? null)}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            className: productStyles.dateTimePickerSlotProps,
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </DemoContainer>
                                                                        </LocalizationProvider>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </>
                                                    }

                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                        <Grid container gap={1} className={globalStyle.displayFlex}>
                                                            <Grid item>
                                                                <Typography className={style.popupFieldTypography}>
                                                                    Flag Multiple Scan
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <PrimaryIOSSwitch
                                                                    checked={qrCode?.flag_multiple_scan}
                                                                    onChange={(e) => onChangeOfQRCodeData(index, 'flag_multiple_scan', e.target.checked)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                        <Grid container gap={1} className={globalStyle.displayFlex} direction={'column'}>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <Typography className={style.popupFieldTypography}>
                                                                    QR Code Header
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <TextField
                                                                    type={'text'}
                                                                    value={qrCode?.ecom_product_qr_code_header}
                                                                    onChange={(e) => onChangeOfQRCodeData(index, 'ecom_product_qr_code_header', e.target.value)}
                                                                    className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth} ${productStyles.qrCodeHeaderTextField}`}
                                                                    placeholder={'Enter QR code header'}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid item xs={12} className={globalStyle.fullwidth}>
                                                        <Grid container gap={1} className={globalStyle.displayFlex} direction={'column'}>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <Typography className={style.popupFieldTypography}>
                                                                    QR Code Description
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} className={globalStyle.fullwidth}>
                                                                <textarea
                                                                    rows={1}
                                                                    placeholder={'Enter QR code description'}
                                                                    className={style.textareaStyle}
                                                                    value={qrCode?.ecom_product_qr_code_description}
                                                                    onChange={(e) => onChangeOfQRCodeData(index, 'ecom_product_qr_code_description', e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {payload?.ecom_product_qr_code_data?.length > 1 && 
                                                        <span className={productStyles.deleteIconWrapper} onClick={() => deleteQrCodeData(index)}>
                                                            <DeleteIcon  className={productStyles.deleteFieldIcon} />
                                                        </span>
                                                    }
                                                </Grid>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>

                <Grid item xs={12} className={globalStyle.fullwidth}>
                    <Grid container className={style.contactPopupButtons}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Cancel"
                                className="borderedButtonStyle"
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                onClick={() => onClickOfCancel()}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={`${selectedProduct ? "Edit" : "Add"}`}
                                className='primaryButtonStyle'
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                disabled={checkDisableSaveButton()}
                                onClick={() => handleCreateClick()}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateSingleProduct
